/**
 * Feature Flag System
 * Centralized exports for feature flag management
 */

// Configuration
export {
  FEATURE_TIERS,
  FEATURE_FLAG_KEYS,
  ALL_FEATURE_FLAGS,
  DEFAULT_FEATURE_FLAGS,
  FEATURE_FLAGS_STORAGE_KEY,
  getFeatureTierForRoute,
  isRouteEnabled,
  shouldRouteShowWarning,
  getFeatureFlagKeyForRoute,
  getOrderedFeatureTiers,
  isInCallFeatureEnabled,
  shouldInCallFeatureShowWarning,
  getInCallFeatureTier,
  isFeatureAccessible,
  shouldShowWarningBadge,
  normalizeFeatureFlagState,
  type FeatureTier,
  type FeatureFlagKey,
  type FeatureFlagState,
  type FeatureTierConfig,
} from './config';

// Hook
export { useUserFeatures, type UseUserFeaturesResult } from './useUserFeatures';
